import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';
import { cva } from 'class-variance-authority';

const featuredIconVariants = cva(
  'relative grid shrink-0 place-content-center rounded-md overflow-hidden [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg]:size-4 border-border-primary border bg-accent inset-shadow-xs inset-shadow-white/10 dark:inset-shadow-white/5 before:absolute before:inset-0 before:bg-gradient-to-t before:from-transparent before:to-white/15 dark:before:to-white/6 before:pointer-events-none',
  {
    variants: {
      size: {
        sm: 'size-8',
        md: 'size-10',
        lg: 'size-12',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  }
);

export function FeaturedIcon(featuredIconProps: ComponentProps<'div'> & VariantProps<typeof featuredIconVariants>) {
  const { className, size, ...props } = featuredIconProps;
  return <div data-slot="featured-icon" className={cn(featuredIconVariants({ size, className }))} {...props} />;
}
